import React from 'react';
import { OPERATION_TYPE } from "../../../../util/varibles/constants";
import { IOperation2 } from "../../../../util/varibles/interface";
import Event from "./Event";
import Harvest from "./Harvest";
import Service from "./Service";
import Support from "./Support";
import Transport from "./Transport";
import Treatment from "./Treatment";

interface IProps {
    isEdit?: boolean
    isApprove: boolean
    data: IOperation2
}

const Info: React.FC<IProps> = (props) => {
    const { isEdit = false, isApprove, data } = props;
    const common = {
        isEdit,
        isApprove,
    }
    const operation = data.operation;

    switch (operation.operation_type) {
        case OPERATION_TYPE.HARVEST:
            return <Harvest {...common} data={{ ...data, operation }} />;
        case OPERATION_TYPE.TREATMENT:
            return <Treatment {...common} data={{ ...data, operation }} />;
        case OPERATION_TYPE.TRANSPORT:
            return <Transport {...common} data={{ ...data, operation }} />;
        case OPERATION_TYPE.SERVICE:
            return <Service {...common} data={{ ...data, operation }} />;
        case OPERATION_TYPE.EVENT:
            return <Event {...common} data={{ ...data, operation }} />;
        case OPERATION_TYPE.SUPPORT:
            return <Support {...common} data={{ ...data, operation }} />;
        default:
            return null;
    }
};

export default Info;
